import { NavLink } from "react-router-dom";
import { Icon } from "../icon/icon";

const navlinks = [
  { name: "Profile", path: "/profile", icon: "user" },
  { name: "Admins", path: "/admin/settings", icon: "users" },
  { name: "Public Holidays", path: "/public/holidays", icon: "beach" },
];

export const SettingsLayout = () => {
  return (
    <div className="w-full md:w-[300px]">
      <nav className="flex flex-row md:flex-col gap-2 w-full">
        {navlinks.map((link, index) => (
          <NavLink
            key={index}
            to={link.path}
            className={({ isActive }) =>
              `w-full group relative flex items-center gap-3 rounded-2xl px-4 py-3 text-grey-950 transition-all ${isActive ? "bg-white" : "hover:bg-grey-50"}`
            }
          >
            <Icon
              svg={link.icon}
              width={20}
              height={20}
              className="mb-1 text-grey-400"
            />
            <p className="text-sm font-bold">{link.name}</p>
            {/* <span className="absolute left-14 top-1/2 hidden -translate-y-1/2 rounded-md z-[9999] bg-white px-2 py-1 text-xs font-bold shadow-md group-hover:block lg:group-hover:hidden">
              {link.name}
            </span> */}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
